import { CommonModule } from "@angular/common";
import { Component, computed, inject, OnInit, signal } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { StateService } from "src/app/Services/state/state.service";

@Component({
  selector: "app-language-component",
  templateUrl: "./language-component.component.html",
  styleUrls: ["./language-component.component.scss"],
  standalone: true,
  imports: [TranslateModule, CommonModule, IonicModule],
})
export class LanguageComponentComponent implements OnInit {
  private translateService = inject(TranslateService);
  private stateService = inject(StateService);

  isLogged = computed(() => !!this.stateService.userInfo()?.username);

  appLanguageList = [
    { code: "en", title: "english", text: "english" },
    { code: "es", title: "spanish", text: "español" },
  ];
  selectedLang = signal<string>(
    (localStorage.getItem("lang") as string) ?? "en",
  );
  isPopoverOpen = signal(false);
  isMobile = signal(window.innerWidth <= 1023);

  constructor() {
    window.addEventListener("resize", this.onResize.bind(this));
  }

  ngOnInit() {}

  ngOnDestroy() {
    // Remove resize listener
    window.removeEventListener("resize", this.onResize.bind(this));
  }

  private onResize(): void {
    this.isMobile.set(window.innerWidth <= 1023);
  }

  toggleLanguage() {
    this.selectedLang.set(this.selectedLang() === "en" ? "es" : "en");
    this.translateService.use(this.selectedLang());
    localStorage.setItem("lang", this.selectedLang());
  }

  setLang(lang: string) {
    this.selectedLang.set(lang);
    this.translateService.use(this.selectedLang());
    localStorage.setItem("lang", this.selectedLang());
  }

  togglePopover() {
    this.isPopoverOpen.update((o) => !o);
  }

  selectLang(lang: string) {
    this.selectedLang.set(lang);
    this.isPopoverOpen.set(false);
  }
}
